
export const PERMISSIONS = {
  FABRIC_CREATE: 'fabric_create',


  THREAD_CREATE: 'thread_create',

  TEMPLATE_CREATE: 'template_create',
  TEMPLATE_UPDATE: 'template_update',
  TEMPLATE_DELETE: 'template_delete',
  TEMPLATE_RUN: 'template_run',

  REPORT_GENERATE: 'report_generate',
  REPORT_DELETE: 'report_delete',
  REPORT_DELETE_MANY: 'report_delete_many',

  ABBREV_GET: 'abbrev_get',
  ABBREV_ADD: 'abbrev_add',
  ABBREV_UPDATE: 'abbrev_update',
  ABBREV_DELETE: 'abbrev_delete',
  ABBREV_SAVE_SELECTION: 'abbrev_save_selection',
  ABBREV_DETECT: 'abbrev_detect',

  AGENT_RESTORE_VERSION: 'agent_restore_version',
  AGENT_RESTORE_PROMPT_VERSION: 'agent_restore_prompt_version',
  AGENT_TRANSLATE_RESPONSE: 'agent_translate_response',
  AGENT_TRANSLATE_CONTEXT: 'agent_translate_context',
  AGENT_MAP_CONTEXT: 'agent_map_context',
  TEMPLATE_RECONFIGURE_DOC_MAPPINGS: 'template_reconfigure_doc_mappings',

  COMMENTS_UPLOAD: 'comments_upload',
  IMPORT_OLD_DOSSIER: 'import_old_dossier',
  CREATE_MANUAL_REFERENCE: 'create_manual_reference',

  REFLIB_LIST: 'reflib_list',
  REFLIB_UPDATE: 'reflib_update',
  REFLIB_FIND_DUPLICATES: 'reflib_find_duplicates',
  REFLIB_MERGE: 'reflib_merge',

  // Developer permission set only (assigned on top of a user's role)
  REPORT_FORMATTING: 'report_formatting',
  SECTION_MANAGEMENT: 'section_management',
};

export const capabilityChecker = (capabilities) => (flag) =>
  capabilities?.[flag] === true;

export default PERMISSIONS;
